import type {
  PageTrackStream,
  EventTrackStream,
  DatalayerInputEvent,
} from '@analytics/models';
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DatalayerEventStream {
  /**
   * Stream used internally in the datalayer that represents a stream of page tracking events.
   */
  pageTrack: PageTrackStream = new ReplaySubject<string>(10);
  /**
   * Stream used internally in the datalayer that represents a stream of event tracking events.
   */
  eventTrack: EventTrackStream = new ReplaySubject<DatalayerInputEvent>(10);
}
